module.exports = __webpack_public_path__ + "static/media/storePurchase_5_10.5c9f125f.png";